// Supabase `experiences` tablosu henüz oluşturulmamışsa veya boşsa gösterilen yedek veri.
// supabase/experiences.sql'deki başlangıç kayıtları da bu listeden üretildi.
// Asıl yönetim admin panelindeki Deneyimler sekmesinden yapılır.

export const FALLBACK_EXPERIENCES = [
  {
    id: 'microsoft-summer-school',
    category: 'work',
    role_tr: 'Yapay Zekâ Stajyeri',
    role_en: 'AI Intern',
    org_tr: 'Microsoft Summer School',
    org_en: 'Microsoft Summer School',
    org_url: 'https://www.microsoft.com/tr-tr',
    location_tr: 'Online · İstanbul ofis ziyaretleri',
    location_en: 'Remote · Istanbul office visits',
    start_date: '2026-07-01',
    end_date: '2026-08-01',
    date_precision: 'month',
    summary_tr: 'Microsoft Foundry Local üzerinde tamamen cihaz içi çalışan Türkçe bir RAG asistanı (Foundry Core AI) geliştirdim. Program boyunca Microsoft Türkiye üst düzey yöneticileriyle haftalık toplantılarda projeyi aşama aşama sundum.',
    summary_en: 'Built Foundry Core AI, a fully on-device Turkish RAG assistant on Microsoft Foundry Local. Presented progress weekly to senior leaders of Microsoft Türkiye throughout the program.',
    highlights_tr: [
      'Dense + BM25 hibrit arama ve RRF ile Türkçeye uygun retrieval katmanı',
      'Cevapları puanlayan değerlendirme seti; uydurma oranını düşürüp başarıyı %60\'tan %79\'a çıkardım',
      '2 GB VRAM\'de model–cihaz dağılımıyla yanıt süresini 80 sn\'den 12–17 sn\'ye indirdim',
    ],
    highlights_en: [
      'Turkish-aware retrieval with dense + BM25 hybrid search fused by RRF',
      'Built an answer-level eval set; cut hallucinations and raised accuracy from 60% to 79%',
      'Reduced latency from 80 s to 12–17 s on a 2 GB GPU by splitting models across devices',
    ],
    tags: ['RAG', 'LLM', 'Foundry Local', 'Python', 'FastAPI', 'SQLite'],
    link_url: '/blog/testler-yesildi-asistan-uyduruyordu-microsoft-stajinda-rag-sistemi-kurarken-ogrendiklerim',
    link_label_tr: 'Staj yazısını oku',
    link_label_en: 'Read the write-up',
    sort_order: 0,
  },
  {
    id: 'founder',
    category: 'work',
    role_tr: 'Kurucu & Geliştirici',
    role_en: 'Founder & Developer',
    org_tr: 'ŞantiyeOS · YurtMarket',
    org_en: 'ŞantiyeOS · YurtMarket',
    org_url: 'https://santiyeos.com.tr/',
    location_tr: 'Bağımsız',
    location_en: 'Independent',
    start_date: '2025-01-01',
    end_date: null,
    date_precision: 'year',
    summary_tr: 'İnşaat firmalarına yönelik çok kiracılı SaaS ürünü ŞantiyeOS\'u ve Bartın\'da 4 öğrenci yurdunda kullanılan e-ticaret platformu YurtMarket\'i tek başıma geliştirip işletiyorum.',
    summary_en: 'I build and run ŞantiyeOS, a multi-tenant SaaS for construction firms, and YurtMarket, an e-commerce platform used across four student dorms in Bartın.',
    highlights_tr: [
      '5 rollü erişim denetimiyle çok kiracılı mimari; ORM\'siz Spring JDBC katmanı',
      'Supabase Row Level Security ile kiracı izolasyonu ve gerçek zamanlı envanter',
    ],
    highlights_en: [
      'Multi-tenant architecture with 5-role access control on an ORM-less Spring JDBC layer',
      'Tenant isolation with Supabase Row Level Security and real-time inventory',
    ],
    tags: ['Spring Boot', 'React', 'Django', 'Supabase', 'MariaDB'],
    sort_order: 0,
  },
  {
    id: 'freelance',
    category: 'work',
    role_tr: 'Yazılım Geliştirici (Serbest)',
    role_en: 'Freelance Software Developer',
    org_tr: 'Doğrudan müşteri projeleri',
    org_en: 'Direct client projects',
    start_date: '2023-07-01',
    end_date: null,
    date_precision: 'month',
    summary_tr: 'Tıbbi ekipman sektöründe bir firmaya özel servis yönetim platformu geliştirdim; sistem canlıda 1.000+ servis formu, teklif ve cihaz kaydını yönetiyor.',
    summary_en: 'Built a custom field-service platform for a medical equipment company; it manages 1,000+ service forms, quotes and device records in production.',
    highlights_tr: [
      'Next.js + PostgreSQL ile cihaz kaydı, servis takibi, teknisyen ataması ve raporlama',
      'React / Next.js + Supabase ile SSR kimlik doğrulama ve gerçek zamanlı veri',
    ],
    highlights_en: [
      'Device registry, service tracking, technician dispatch and reporting with Next.js + PostgreSQL',
      'SSR authentication and real-time data with React / Next.js + Supabase',
    ],
    tags: ['Next.js', 'PostgreSQL', 'Supabase'],
    sort_order: 1,
  },
  {
    id: 'marmara',
    category: 'education',
    role_tr: 'Veri Analizi Uzmanlık Programı',
    role_en: 'Data Analysis Specialization Program',
    org_tr: 'Marmara Üniversitesi — Nüfus ve Sosyal Araştırmalar Enstitüsü (YÖK)',
    org_en: 'Marmara University — Institute of Population and Social Research (YÖK)',
    start_date: '2025-10-01',
    end_date: '2026-05-01',
    date_precision: 'month',
    sort_order: 0,
  },
  {
    id: 'bartin',
    category: 'education',
    role_tr: 'Lisans — Bilgisayar Teknolojisi ve Bilişim Sistemleri',
    role_en: 'B.Sc. — Computer Technology and Information Systems',
    org_tr: 'Bartın Üniversitesi',
    org_en: 'Bartın University',
    start_date: '2022-09-01',
    end_date: null,
    date_precision: 'month',
    sort_order: 0,
  },
  {
    id: 'codenthia',
    category: 'community',
    role_tr: 'Kurucu & İçerik Üreticisi',
    role_en: 'Founder & Content Creator',
    org_tr: 'Codenthia',
    org_en: 'Codenthia',
    start_date: '2024-01-01',
    end_date: null,
    date_precision: 'year',
    summary_tr: '7.200+ takipçili yazılım ve teknoloji içerik hesabını yönetiyorum; 330+ gönderiyle düzenli içerik üretiyorum.',
    summary_en: 'I run a software and tech content account with 7,200+ followers and 330+ posts.',
    sort_order: 0,
  },
  {
    id: 'bartinchain',
    category: 'community',
    role_tr: 'Yönetim Ekibi Üyesi',
    role_en: 'Board Member',
    org_tr: 'BartınChain — Blockchain Topluluğu',
    org_en: 'BartınChain — Blockchain Community',
    start_date: '2023-11-01',
    end_date: '2025-12-01',
    date_precision: 'month',
    summary_tr: 'Teknik içerik üretimi (Medium), etkinlik organizasyonu ve seminerler.',
    summary_en: 'Technical writing on Medium, event organization and seminars.',
    sort_order: 0,
  },
];
